import { useApiPrivateRequest } from "@/shared/hooks/useApi";
import { PlaybooksSettings } from "../models/PlaybooksSettings";

export const useUpdatePlaybooksSettings = () => {
  const { data, call, isLoading, isFailed } =
    useApiPrivateRequest<PlaybooksSettings>(
      (response) => new PlaybooksSettings(response),
    );

  const updatePlaybooksSettings = async (settings: PlaybooksSettings) => {
    await call("/playbooks/settings", "PUT", undefined, settings);
  };

  return {
    updatePlaybooksSettings,
    updatedPlaybookSettings: data,
    isLoading,
    isFailed,
  };
};
